<template>
	<div class="container" v-wechat-title="$route.meta.title">
		<div class="topTitle"><img style="opacity: 0;" class="backImg" src="../assets/pingzi/back.png" alt="">{{$route.meta.title}}</div>
		<div style="width: 100%;height: 0.8rem;background: transparent;"></div>
		<img class="topImg" src='../assets/icon/paySuccess.png' />
		<!-- 顶部文字描述 -->
		<div class="topDes">
			<div class="topBox">
				<span class="">支付失败</span>
			</div>
		</div>
		<!-- 按钮 -->
		<div class="btn1 btn bgBaseColor" hover-class="btnHover" @click="goCenter">
			<span class="">返回</span>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import util from '../utils/util'
	import {
		Toast
	} from 'vant';
	import {
		RadioGroup,
		Radio
	} from 'vant';
	Vue.use(RadioGroup);
	Vue.use(Radio);
	import {
		Loading
	} from 'vant';
	Vue.use(Loading);

	Vue.use(Toast);
	import baseUrl from '../utils/basedata.js'

	export default {
		name: 'paySuccess',
		data() {
			return {
				
			}
		},
		created: function() {
			this.$emit('footer', false);
		},
		components: {},
		methods: {
			goCenter() {
				this.$router.go(-1);
				// this.$router.push({
				// 	path: 'mine',
				// 	query: {}
				// })
			},
		},
		mounted() {
			
		},
		beforeDestroy() {
			
		}
	}
</script>

<style scoped lang="scss">
	@import url("../styles/base1.css");

	.container {
		width: 100%;
		min-height: 100vh;
		box-sizing: border-box;
		// padding: 0.15rem;
		background-color: white;
	}

	.topImg {
		width: 100%;
		height: 2.66rem;
	}

	.topDes {
		box-sizing: border-box;
		font-size: 0.38rem;
		// background: #f5f5f5;
		color: #383838;
		text-align: center;
		.topBox {
			width: 2.2rem;
			height: 0.3rem;
			margin: 0.5rem auto;
			img {
				width: 0.3rem;
				height: 0.3rem;
				margin-right: 0.3rem;
			}
		}
	}

	.btn1 {
		width: 6rem;
		height: 0.8rem;
		line-height: 0.8rem;
		color: #fff;
		margin: 2rem auto 0.5rem auto;
	}

	.btn2 {
		width: 5.96rem;
		height: 0.76rem;
		line-height: 0.8rem;
		color: #4FAE54;
		box-sizing: border-box;
		margin: 0.2rem auto 1rem auto;
		border: 0.02rem solid #4FAE54;
	}
</style>
